var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ee-form-item",
    class: {
      'is-error': _vm.errMsg
    },
    style: (_vm.style)
  }, [(_vm.label) ? _c('div', {
    staticClass: "ee-form-item__label",
    class: {
      'is-required': _vm.isRequired
    },
    style: ({
      width: (_vm.labelWidth + "px")
    })
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ee-form-item__content",
    style: ({
      marginLeft: (_vm.labelWidth + "px")
    })
  }, [_vm._t("default"), _vm._v(" "), _c('span', {
    staticClass: "ee-form-item__bottom-bar"
  }, [_vm._t("bttom-bar")], 2), _vm._v(" "), _c('span', {
    staticClass: "ee-form-item__error-msg"
  }, [_vm._v(_vm._s(_vm.errMsg))])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78ef5d2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/form/FormItem.vue
// module id = 571
// module chunks = 13